import React, { useEffect, useState } from 'react';
import { login } from "./Api.js";

function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    useEffect(() => {
        import('./Login.css');
    }, []);

    const loginEvt = async (event) => {
        event.preventDefault();
        console.log('Fazendo login com:', username, password);
        let result = await login(username, password);
        if (result == null || result.data == null) {
            alert('Credenciais inválidas');
        } else {
            sessionStorage.setItem('logged', 'true');
            sessionStorage.setItem('domain', result.data.corporation);
            sessionStorage.setItem('user', result.data.username);
            if (result.data.clientId)
                sessionStorage.setItem('clientId', result.data.clientId);
            window.location.reload();
        }
    };

    return (
        <div className="login-container">
            <div
                className="login-box"
                style={{
                    background: "#ffffff",
                    borderRadius: "12px",
                    padding: "40px 60px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    maxWidth: "400px",
                    width: "100%",
                    textAlign: "center",
                    opacity: 0.95,
                }}
            >
                <img
                    src={require("./logo.png")}
                    alt="Logo"
                    className="logo"
                    style={{
                        maxWidth: "140px",
                        marginBottom: "20px",
                    }}
                />
                <h2
                    style={{
                        fontSize: "28px",
                        color: "#1e3a8a",
                        fontWeight: "bold",
                        marginBottom: "16px",
                    }}
                >
                    Bem-vindo de volta!
                </h2>
                <p
                    style={{
                        fontSize: "16px",
                        color: "#475569",
                        marginBottom: "24px",
                    }}
                >
                    Por favor, entre em sua conta para continuar
                </p>

                <form
                    className="login-form"
                    onSubmit={loginEvt}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                    }}
                >
                    <input
                        type="text"
                        placeholder="Email ou Nome de Usuário"
                        className="input-field"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "14px",
                            border: "1px solid #dbeafe",
                            borderRadius: "8px",
                            fontSize: "16px",
                            color: "#334155",
                        }}
                    />
                    <input
                        type="password"
                        placeholder="Senha"
                        className="input-field"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{
                            width: "100%",
                            padding: "14px",
                            border: "1px solid #dbeafe",
                            borderRadius: "8px",
                            fontSize: "16px",
                            color: "#334155",
                        }}
                    />
                    <button
                        type="submit"
                        className="login-button"
                        style={{
                            width: "100%",
                            padding: "14px",
                            backgroundColor: "#1e3a8a",
                            color: "#ffffff",
                            border: "none",
                            borderRadius: "8px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                        }}
                    >
                        Entrar
                    </button>
                </form>

                <div
                    className="login-footer"
                    style={{
                        marginTop: "24px",
                        textAlign: "center",
                    }}
                >
                    {/* <p
                        style={{
                            fontSize: "14px",
                            color: "#64748b",
                        }}
                    >
                        Não tem uma conta?{" "}
                        <a
                            href="#"
                            style={{
                                color: "#1e3a8a",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Cadastre-se
                        </a>
                    </p> */}
                    {/* <p
                        style={{
                            fontSize: "14px",
                            color: "#64748b",
                        }}
                    >
                        Esqueceu sua senha?{" "}
                        <a
                            href="#"
                            style={{
                                color: "#1e3a8a",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Recupere-a aqui
                        </a>
                    </p> */}
                </div>
            </div>
        </div>
    );
}

export default Login;
